export default __webpack_public_path__ + "static/media/click.9fe2c188.svg";